export default "__VITE_ASSET__BEYeu3fx__"